import * as types from '../mutation-types'

// the root, initial state object
const state = {
  user: {}
}

// define the possible mutations that can be applied to our state
const mutations = {
  [types.SET_USERINFO] (state, initData) {
    state.user = initData
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/user.js